import React, { useState } from "react";
import "./TourPackages.css";
import { FaWhatsapp } from "react-icons/fa";
import { BASE_URL } from "../../../Components/Base_url/Base_Url";

function Card({ service }) {
    const [expandedPara, setExpandedPara] = useState({});

    const getShortText = (text, wordLimit = 10) => {
        if (!text) return "";
        const words = text.split(" ") || [];
        if (words.length <= wordLimit) return text;
        return words.slice(0, wordLimit).join(" ") + " ...";
    };

    return (
        <section className="tour-packages">
            <div className="container">
                <div className="packages-container">
                    {service.map((service, index) => (
                        <div className="package-item" key={index}>
                            <div className="package-image">
                                <img
                                    src={service.img ? `${BASE_URL}${service.img}` : "/img/Imges Call-for -cabsss/logo-1  (2) (1).png"}
                                    alt={service.name || "Tour Package"}
                                    loading="lazy"
                                />
                            </div>

                            <div className="package-content">
                                <h6 className="package-title">{service.name}</h6>

                                <div className="package-info">
                                    <span className="package-duration">
                                        <i className="far fa-clock" dangerouslySetInnerHTML={{ __html: service.extra }}></i>
                                    </span>
                                    <span
                                        className="package-price"
                                        dangerouslySetInnerHTML={{ __html: service.remarks }}
                                    ></span>
                                </div>

                                <div className="package-description">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: expandedPara[service.Service_id]
                                                ? service.Paragraph
                                                : getShortText(service.Paragraph, 10),
                                        }}
                                    />
                                    {(service.Paragraph?.split(" ").length || 0) > 10 && (
                                        <button
                                            onClick={() =>
                                                setExpandedPara(prev => ({
                                                    ...prev,
                                                    [service.Service_id]: !prev[service.Service_id],
                                                }))
                                            }
                                            className="read-more-btn"
                                        >
                                            {expandedPara[service.Service_id] ? "Show less" : "Read more"}
                                        </button>
                                    )}
                                </div>

                                <div className="package-buttons">
                                    <a href={`/service-detail/${service.slug}`} className="btn view-details-btn">
                                        View Details
                                    </a>
                                    <a
                                        href={`https://wa.me/9116839808?text=Hi, I am interested in the ${service.name} package.`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn whatsapp-btn"
                                    >
                                        <FaWhatsapp size={20} /> WhatsApp
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Card;